import { FilterDropdown } from '@ui';
import { useInfiniteTXCentersListQuery } from '@/queries/tx-centers';
import { useAsyncSearchableList } from '@/hooks/useAsyncSearchableList';
import { NameByValue } from '@/types';

type TXCentersFilterDropdownProps = {
  selectedKeys: string[];
  onSelectedKeysChange: (value: string[]) => void;
  showResetButton?: boolean;
};

export const TXCentersFilterDropdown = ({
  selectedKeys,
  onSelectedKeysChange,
  showResetButton,
}: TXCentersFilterDropdownProps) => {
  const {
    list: txCentersList,
    isLoading: isTxCentersLoading,
    hasNextPage: hasNextTxCentersPage,
    loadNextPage: loadNextTxCentersPage,
    setSearchValue: onTXCentersSearch,
  } = useAsyncSearchableList({
    query: useInfiniteTXCentersListQuery,
  });

  return (
    <FilterDropdown
      title="TX Center"
      items={txCentersList as NameByValue<string>[]}
      selectedKeys={selectedKeys}
      mode="multiple"
      size="sm"
      hasNextPage={hasNextTxCentersPage}
      isLoading={isTxCentersLoading}
      loadNextPage={loadNextTxCentersPage}
      onSearchValue={onTXCentersSearch}
      onSelectedKeysChange={onSelectedKeysChange}
      showResetButton={showResetButton}
    />
  );
};
